import {
	SendCrossPlatformAction,
	SendCrossPlatformEmailError,
} from './send-cross-platform-email';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';

export const sendCrossPlatformSuccessMock: SendCrossPlatformAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_NO_CONTENT,
	});
};

export const sendCrossPlatformValidationErrorMock: SendCrossPlatformAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		error: SendCrossPlatformEmailError.EmailInvalidFormat,
	});
};

export const sendCrossPlatformInternalErrorMock: SendCrossPlatformAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
	});
};

export const sendCrossPlatformMailMocks: {
	// V2
	sendCrossPlatformMailSuccess: SendCrossPlatformAction;
	sendCrossPlatformMailValidationError: SendCrossPlatformAction;
	sendCrossPlatformMailInternalError: SendCrossPlatformAction;
} = {
	sendCrossPlatformMailSuccess: sendCrossPlatformSuccessMock,
	sendCrossPlatformMailValidationError: sendCrossPlatformValidationErrorMock,
	sendCrossPlatformMailInternalError: sendCrossPlatformInternalErrorMock,
};
